import { IonPopover } from '@ionic/react';
import styled from 'styled-components';

export const Wrapper = styled.div``;

export const PopoverWrapper = styled(IonPopover)`
  .button-icon {
    margin-inline-start: 0;
    margin-top: 12px;
    margin-bottom: 12px;
    width: 48px;
    height: 48px;

    &.disabled {
      color: var(--ion-color-lightest-shade);
    }
  }

  .action-button {
    border-radius: 5px;

    --background: var(--ion-color-light);
    --color: var(--ion-color-light-contrast);

    &.disabled {
      --background: var(--ion-color-lightest);
      --color: var(--ion-color-lightest-shade);
    }
  }

  .media-divider {
    border-radius: 5px;
    font-weight: normal;

    .item-divider-wrapper {
      justify-content: center;
    }

    &.photos {
      --background: var(--ion-color-primary);
      --color: var(--ion-color-primary-contrast);
    }
    &.videos {
      --background: var(--ion-color-tertiary);
      --color: var(--ion-color-tertiary-contrast);

      &.disabled {
        --background: var(--ion-color-light);
        --color: var(--ion-color-lightest-shade);
      }
    }
  }
`;
